import React from 'react';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';

export const AvatarAnimation = ({ children, shouldShowTooltip }) => {
  const variants = {
    enter: {
      opacity: 1,
      display: 'block',
      transition: { default: { duration: 0.15, ease: 'easeInOut' } },
    },
    dismiss: {
      opacity: 0,
      transitionEnd: { display: 'none' },
      transition: { default: { delay: 0.15, duration: 0.25, ease: 'easeInOut' } },
    },
  };

  return (
    <motion.div
      initial="dismiss"
      animate={shouldShowTooltip ? 'enter' : 'dismiss'}
      variants={variants}
    >
      {children}
    </motion.div>
  );
};

AvatarAnimation.propTypes = {
  children: PropTypes.object.isRequired,
  shouldShowTooltip: PropTypes.bool.isRequired,
};
